<div class="profile-section">
  <ul class="p-1 hidden origin-bottom animation-duration-150 overflow-hidden animation-ease-in-out">
    <!-- <li>
      <a [routerLink]="['/platform/profile']" pRipple class="flex items-center gap-4 cursor-pointer">
        <i class="pi pi-user"></i>
        <span>Profil</span>
      </a>
    </li> -->
    <li>
      <app-logout></app-logout>
    </li>
  </ul>
  <a pRipple class="flex items-center gap-4 cursor-pointer mt-2 mb-2" pStyleClass="@prev" enterFromClass="hidden"
    enterActiveClass="slidedown" leaveToClass="hidden" leaveActiveClass="slideup">

    <div *ngIf="user" class="flex items-center gap-2">
      @if (user.avatar) {
      <p-avatar styleClass="flex" size="normal" shape="circle" [image]="user.avatar" />
      } @else {
      <p-avatar styleClass="flex" size="normal" shape="circle" label="{{ user.initials }}"
        [style]="{ 'background-color': '#ece9fc', color: '#2a1261' }" />
      }
      <span class="font-medium">{{ user.firstName }} {{ user.lastName }}</span>
    </div>

    <i class="pi pi-chevron-up ml-auto"></i>
  </a>
</div>